class User {
  _id = '';
  email = '';
  password = '';
}

module.exports = User;
